import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { StyledLayout } from './Layout.styles';
export var Layout = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      align = _ref.align,
      columnGap = _ref.columnGap,
      direction = _ref.direction,
      justify = _ref.justify,
      rowGap = _ref.rowGap,
      wrap = _ref.wrap,
      restProps = _objectWithoutProperties(_ref, ["children", "align", "columnGap", "direction", "justify", "rowGap", "wrap"]);

  return React.createElement(StyledLayout, _objectSpread({
    outerSpacing: useSpacing(restProps),
    align: align,
    columnGap: columnGap,
    direction: direction,
    justify: justify,
    ref: ref,
    rowGap: rowGap,
    wrap: wrap
  }, pickComponentCommonProps(restProps)), children);
});
Layout.displayName = 'Layout';